import React from "react";
import { Link } from "react-router-dom";

const NotAuthenticated = () => {

  return (
    <div className="">
      <div className="row">
        <div className="col-lg-12 d-flex justify-content-center align-items-center flex-column" style={{height: "100vh"}}>
            <h1>403 Error</h1>
            <p>you arent authenticated</p>
            <Link to={"/dashboard"} className="btn btn-info p-2">&#8592; Return to dashboard</Link>
        </div>
      </div>
    </div>
  );
};

export default NotAuthenticated;
